import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface ReportKtxh {
  name: string;
  api_token: string;
}

export interface ReportKtxhDetaiInfor {
  errors: unknown;
  ReportKtxh: ReportKtxh;
  isAuthenticated: boolean;
}

@Module
export default class ReportKtxhDetail
  extends VuexModule
  implements ReportKtxhDetaiInfor
{
  errors = {};
  ReportKtxh = {} as ReportKtxh;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get ReportKtxhDetail() {
    return this.reportKtxhDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.REPORT_KTXH_DETAIL_DATA](ReportKtxh) {
    this.reportKtxhDetailData = ReportKtxh;
  }
  @Action
  [Actions.REPORT_KTXH_DETAIL](payload) {
    return ApiService.getDataDetail("/report_ktxh", payload, "detail", payload)
      .then(({ data }) => {
        this.context.commit(Mutations.REPORT_KTXH_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
